import { render } from "./StaffDetail.vue?vue&type=template&id=8c6a2228&ts=true"
import script from "./StaffDetail.vue?vue&type=script&lang=ts"
export * from "./StaffDetail.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__